<div id="body" [ngClass]="{'no-footer': (hideFooter$ |async)}">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="!(hideFooter$ |async)" id="footer"></app-footer>
